import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'

import homePage from './pages/homePage'
import OctopusPage from './pages/octopusPage'
import OtterioPage from './pages/otterioPage'
import DVoucherPage from './pages/dVoucherPage'
import EKycPage from './pages/eKycPage'
import BillPayPage from './pages/billPayPage.js'
import OctopusEdcQRPage from './pages/octopus-edc-qr.js'
import WalletCoreServicePage from './pages/walletServicePage'
import PlanetxServicePage from './pages/planetxPage.js'
import PlanetxPortalServicePage from './pages/planetXPortalServicePage.js'
import PlanetxExternalPage from './pages/planetxExternalPage.js'

function App() {
  return (
    <Router>
      <Switch>
        <Route path='/documents/octopus' component={ OctopusPage } />
        <Route path='/documents/octopus-edc-qr' component={ OctopusEdcQRPage } />
        <Route path='/documents/otterio' component={ OtterioPage } />
        <Route path='/documents/d-voucher' component={ DVoucherPage } />
        <Route path='/documents/e-kyc' component={ EKycPage } />
        <Route path='/documents/billpay' component={ BillPayPage } />
        <Route path='/documents/wallet-service' component={ WalletCoreServicePage } />
        <Route path='/documents/planetx-service' component={ PlanetxServicePage } />
        <Route path='/documents/planetx-portal-service' component={ PlanetxPortalServicePage } />
        <Route path='/documents/planetx-external' component={ PlanetxExternalPage } />
        <Route component={ homePage } />
      </Switch>
    </Router>
  )
}

export default App
